(function ($, Drupal) {
  Drupal.behaviors.klimaLightbox = {
    attach: function (context, settings) {
      const lightbox = GLightbox({
        selector: '.colorbox'
      });
      const lightboxInlineIframe = GLightbox({
        selector: '.quiz-lightbox-de, .quiz-lightbox-en',
        height: '90vh'
      });
    }
  }
})(jQuery, Drupal);
